import { Avatar, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { RadioChecked, RadioIcon } from 'Images';
import { useFormContext, Controller } from 'react-hook-form';

interface IRadioInput {
  name: string;
  options: { label: string; value: number | boolean | null }[];
}

export const RadioInput = ({ name, options }: IRadioInput) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <RadioGroup
          sx={{ flexDirection: 'row', gap: '64px' }}
          value={value}
          onChange={onChange}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.label}
              sx={{ m: 0 }}
              componentsProps={{
                typography: {
                  variant: 'body3',
                  mr: '-6px',
                },
              }}
              value={option.value}
              control={
                <Radio
                  icon={
                    <Avatar
                      alt=''
                      src={RadioIcon}
                      sx={{ width: '20px', height: '20px', ml: '-10px' }}
                    />
                  }
                  checkedIcon={
                    <Avatar
                      alt=''
                      src={RadioChecked}
                      sx={{ width: '20px', height: '20px', ml: '-10px' }}
                    />
                  }
                />
              }
              label={option.label}
            />
          ))}
        </RadioGroup>
      )}
    />
  );
};
